import React from 'react';
import { useLocation } from 'react-router-dom';
import './styles/ShopNavigationDetails.css';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from "../firebase/config";

const ShopNavigationDetails = () => {
      const navigate = useNavigate();
  const { state } = useLocation();

  const {
    shopName,
    productName,
    productImage,
    price,
    updated,
    distance,
    address,
    imageUrl,
    units,
    contact,
    alternateContact,
    bannerImageUrl,
    rating = 4.5,
    vendorLat,
    vendorLng,
    userLocation,
     user
  } = state;
  const openGoogleMaps = async () => {
    const start = `${vendorLat},${vendorLng}`;
    const encodedDestination = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${start}&destination=${encodedDestination}&travelmode=driving`;
    window.open(mapsUrl, '_blank');

try {
      const dealInterest = httpsCallable(functions, "addDealInterest");
      dealInterest({
        user_id: user.email,
        shop_id: contact,
        product: productName,
        price: price,
        distance: distance
      }).then(res => {
        console.log("Deal interest recorded:", res.data);
      }).catch(err => {
        console.warn("Deal interest error (non-blocking):", err.message);
      });
    } catch (err) {
      console.warn("Unexpected error during deal interest:", err.message);
    }
};

  if (!state) return <div>No shop data available.</div>;

  

  // Optional phone numbers
  const vendorPhone1 = `tel:${contact}`;
  const vendorPhone2 = `tel:${alternateContact}`;

  return (
    <div className="shop-details-container">
      <div className="user-header">
  <div className="profile">
    <img src={user.photoURL} alt="avatar" className="avatar" />
    <div className="user-info-text">
      <h4>{user.name}</h4>
      <p>{user.email}</p>
    </div>
    <div className="product-info">
             <img src={productImage} alt="product" className="avatar" />
             <p className="product-name">{productName}</p>
    </div>
  </div>
</div>

      <div className="location-bar">
        <span className="location-icon"><b>Shop Location📍:</b></span> {address}
      </div>

      <div className="shop-banner">
        <img src={imageUrl} alt="Shop Banner" />
      </div>

      <div className="shop-info-card">
        <h1>{shopName}</h1>
        <div className="shop-meta">
          <h3>📍Distance from your location(aprx.)  {distance} K.M</h3>
          {/* <span>Google rating: {rating}/5</span> */}
        </div>

        <div className="price-section">
          <h2>Deal price : ₹{price} Rs/{units}</h2>
          <p className="updated-text">
            <strong>Last updated on {new Date(updated).toLocaleDateString()}</strong>
          </p>
        </div>

        <p className="note">
          <b>Note:</b> <br />
          As deal is not updated from last three days, you are advised to contact vendor to confirm today’s price.
        </p>

    <div className="action-buttons-row">
  {/* Contact Vendor section with Call buttons inside */}
  {(contact || alternateContact) && (
    <div className="contact-vendor-group">
      <p className="contact-label">Contact Vendor:</p>
      <div className="call-buttons">
        {contact && (
          <a href={`tel:${contact}`} className="btn small-btn call-btn">
            📞 Call Vendor
          </a>
        )}
        {alternateContact && (
          <a href={`tel:${alternateContact}`} className="btn small-btn call-btn">
            📞 Call Alternate
          </a>
        )}
      </div>
    </div>
  )}

  {/* Lock Deal button */}
  <button className="btn lock full-btn" onClick={openGoogleMaps}>
    Lock the Deal & Start Map
  </button>
</div>



      </div>
    </div>
  );

};

export default ShopNavigationDetails;
